//@ts-ignore
import { DashboardLayout as DashboardLayoutService } from "@careinfo/layout";
import OverViewIcon from "../Icons/OverViewIcon";
import { Outlet } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import ProfileIcon from "../Icons/ProfileIcon";
import SecurityIcon from "../Icons/SecurityIcon";
import ActivityIcon from "../Icons/ActivityIcon";
import AttendenceIcon from "../Icons/AttendenceIcon";

export const navigation: any = [
  {
    name: "Account Setting",
    href: "",
    icon: "",
    children: [
      {
        name: "My Profile",
        href: "/profile/my-profile",
        icon: ProfileIcon,
        activeIcon: ProfileIcon,
      },
      {
        name: "Security",
        href: "/profile/security",
        icon: SecurityIcon,
        activeIcon: SecurityIcon,
      },
      {
        name: "Activity Log",
        href: "/profile/activity-log",
        icon: ActivityIcon,
        activeIcon: ActivityIcon,
      },
      {
        name: "Attendence",
        href: "/profile/attendence",
        icon: AttendenceIcon,
        activeIcon: AttendenceIcon,
      },
    ],
  },
];

const DashboardLayout = () => {
  return (
    <DashboardLayoutService navigation={navigation}>
      <div className={tw`h-full p-2 overflow-y-auto`}>
        <Outlet />
      </div>
    </DashboardLayoutService>
  );
};

export default DashboardLayout;
